/**
 * Vue Router configuration
 * @module router
 */
import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../store/authStore';

/**
 * Router configuration with routes
 * @type {import('vue-router').Router}
 */
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/museums',
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/Login.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/museums',
      name: 'Museums',
      component: () => import('../views/MuseumList.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/codes',
      name: 'VerificationCodes',
      component: () => import('../views/VerificationCodeList.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/verify',
      name: 'VerificationCheck',
      component: () => import('../views/VerificationCheck.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/unlock.html',
      name: 'H5Decrypt',
      component: () => import('../views/H5Decrypt.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/location-test',
      name: 'LocationTest',
      component: () => import('../views/LocationTest.vue'),
      meta: { requiresAuth: false },
    },
  ],
});

/**
 * Global navigation guard
 */
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  // If the route requires authentication
  if (to.meta.requiresAuth !== false) {
    // Check if user is authenticated
    if (!authStore.isAuthenticated) {
      // Redirect to login page
      next({ name: 'Login' });
      return;
    }

    // If user info is not loaded, try to fetch it
    if (!authStore.user && authStore.token) {
      try {
        await authStore.fetchCurrentUser();
      } catch (error) {
        // If fetching user fails, redirect to login
        next({ name: 'Login' });
        return;
      }
    }
  }

  // For login page, redirect to museums if already authenticated
  if (to.name === 'Login' && authStore.isAuthenticated) {
    next({ name: 'Museums' });
    return;
  }

  next();
});

export default router;
